module.exports = __webpack_public_path__ + "static/media/home_banner.70a41db0.png";